<template>
  <div>
    <h3>Based on your previous Diabetic Risk Report, did you care provider recommend any diet or lifestyle changes?</h3>
    <v-form-group class="card-selector" :validator="$v.careProvider">
      <b-form-checkbox v-model="survey.careProvider.isDiet" @change="(value) => setOptions(value, survey.careProvider.isLifestyle, false)">Diet</b-form-checkbox>
      <b-form-checkbox v-model="survey.careProvider.isLifestyle" @change="(value) => setOptions(survey.careProvider.isDiet, value, false)">Lifestyle</b-form-checkbox>
      <b-form-checkbox v-model="survey.careProvider.isNoChanges" @change="(value) => setOptions(false, false, value)">No Recommended Changes</b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      careProvider: {
        anyOptionRequired: anyOptionRequired((value) => value.isDiet || value.isLifestyle || value.isNoChanges)
      }
    },

    computed: {
      ...mapState(["survey"]),

      careProvider() { return this.survey.careProvider }
    },

    methods: {
      onSubmit() {

      },

      setOptions(isDiet, isLifestyle, isNoChanges) {
        this.survey.careProvider.isDiet = isDiet;
        this.survey.careProvider.isLifestyle = isLifestyle;
        this.survey.careProvider.isNoChanges = isNoChanges;
      }
    }
  };
</script>